import moment from 'moment';
import lodash from 'lodash';

export const processesMechanical = [
  {
    check_point: 'मशीन बेड की सफाई !',
    check_outline: 'देखकर चेक करे ! ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'मशीन बॉडी की सफाई!',
    check_outline: 'देखकर चेक करे ! ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'लुब्रिकेशन आयल !',
    check_outline: 'देखकर चेक करे ! ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'स्टार्टर  काम करना ',
    check_outline: 'मशीन स्टार्ट करके चेक करे',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'स्प्रिंग , बोल्ट इत्यादि चेक करना टुटा हुआ तोह नहीं ! ',
    check_outline: 'हाथ से चेक करे ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'बेल्ट तनाव चेक करना !',
    check_outline: 'हाथ से चेक करे ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'रेम गाइड का बोल्ट चेक करना !',
    check_outline: 'हाथ से चेक करे ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'ज्यादा आयल लीकेज न हो !',
    check_outline: 'देखकर चेक करे ! ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'फुट  पेडल लीवर सही तरह से काम  करना !',
    check_outline: 'पेडल दबा कर चेक करे ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'चक नट बोल्ट तथा टूल क्लैंप चेक करना !',
    check_outline: 'हाथ से चेक करे ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'मशीन पे सेफ्टी गार्ड लगा होना !',
    check_outline: 'पूरी तरह घूमना चाहिए ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
];

export const initialStateMechanical = {
  isSubmitted: false,
  is_admin_request_no: null,
  is_admin_request: null,
  report_prepared_by: null,
  report_approved_by: null,
  machine_id: null,
  moduleData_date: moment(),
  // month: '',
  processes: lodash.cloneDeep(processesMechanical),
};

// for pnumetic
export const processesPnumetic = [
  {
    check_point: 'मशीन का इमरजेंसी स्टॉप बटन काम कर रहे हैं ',
    check_outline: 'हाथ से दबाकर ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'मशीन के TWO/ HANDS वाले स्विच काम कर रहे हैं ',
    check_outline: 'हाथ से दबाकर ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'मशीन का ऑन ऑफ बटन  काम कर रहा हैं ',
    check_outline: 'हाथ से दबाकर ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },

  {
    check_point: 'मशीन का कोई भी नंगा तार नहीं होना चाहिए ',
    check_outline: 'देख कर ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'सेफ्टी उपकरण पहने हुए  होना चाहिए',
    check_outline: 'देख कर ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'इलेक्ट्रिक पैनल लॉक होना चाहिए',
    check_outline: 'देख कर ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point:
      'पुश बटन में किसी भी तरह के कॉटन, स्क्रैप और वायर का इस्तेमाल न करें',
    check_outline: 'देख कर ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'फोटो गार्ड सेंसर काम कर रहे हैं',
    check_outline: 'देख कर ',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
  {
    check_point: 'मशीन में ABNORMAL SOUND  नहीं होना चाहिए ',
    check_outline: 'कान से सुनकर',
    results: Array.from({ length: 31 }, () => ''),
    remarks: '',
  },
];

export const initialStatePnumetic = {
  isSubmitted: false,
  is_admin_request_no: null,
  is_admin_request: null,
  report_prepared_by: null,
  report_approved_by: null,
  machine_id: null,
  moduleData_date: moment(),
  // month: '',
  processes: lodash.cloneDeep(processesPnumetic),
};
